import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// views
import { AddButton, FormButtonsWrapper } from 'components/Modals/PlanColumnsSettingsModal/views'
// types
import { IOption } from 'components/FormElements/Select'
// themes
import colors from 'themes/colors'
// utils
import { required } from 'utils/validators'

const FieldsWrapper = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  background: ${colors.gray190};
  border-radius: 4px;
  padding: 8px 12px;
`

interface Props {
  name: string
  options: IOption[]
  onSave: () => void
  onCancel: () => void
}

const ColumnForm: React.FC<Props> = ({ name, options, onSave, onCancel }) => {
  return (
    <FieldsWrapper>
      <ReduxSelect name={`${name}.field`} label={'Column'} options={options} validate={required} />
      <ReduxInput name={`${name}.width`} label={'Column Width'} type={'number'} />
      <FormButtonsWrapper>
        <AddButton onClick={onSave}>save</AddButton>
        <AddButton onClick={onCancel}>cancel</AddButton>
      </FormButtonsWrapper>
    </FieldsWrapper>
  )
}

export default ColumnForm
